import { OrganizationDomains } from 'types/organization';

export const getBaseOrganizationDomain = ({
	hostname,
	customId,
}: {
	hostname: string;
	customId: string;
}): ArrayType<OrganizationDomains> => ({
	id: null,
	domain: `${hostname}/${customId}`,
	type: 'Default',
	status: 'valid',
	prefixes: null,
});

type GetStoryCustomDomainProps = {
	domainId: ArrayType<OrganizationDomains>['id'];
	domains: OrganizationDomains;
};

export const findStoryCustomDomain = (props: GetStoryCustomDomainProps) => {
	return props.domains?.find?.(domain => domain.type === 'Custom' && `${domain.id}` === `${props.domainId}`);
};

/** Props for UrlHelper.getPublishedUrl from selected org custom domain. */
export const getStoryPublishedDomainProps = (props: GetStoryCustomDomainProps) => {
	const entry = findStoryCustomDomain(props);
	if (!entry) return {};
	return {
		customDomain: entry.domain,
		pathPrefixes: entry.prefixes,
	};
};

// get url to story by custom domain id
export const getStoryCustomDomain = (props: GetStoryCustomDomainProps) => {
	return findStoryCustomDomain(props)?.domain;
};
